<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" name="建档信息"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <table class="ui-box-table">
        <tr>
          <td style="width:12%">档案号</td>
          <td style="width:19%">{{data.tbArchiveNumber||'-'}}</td>
          <td style="width:12%">紧急联系人</td>
          <td style="width:19%">{{data.tbContact||'-'}}</td>
          <td style="width:12%">联系人号码</td>
          <td style="width:26%">{{data.tbContactPhone||'-'}}</td>
        </tr>
        <tr>
          <td style="width:12%">绑定医院</td>
          <td style="width:19%">{{data.tbHospitalName||'-'}}</td>
          <td style="width:12%">科室</td>
          <td style="width:19%">{{data.tbDepartmentName||'-'}}</td>
          <td style="width:12%">关联医生</td>
          <td style="width:26%">{{data.tbDoctorName||'-'}}</td>
        </tr>
        <template v-if="data.currentGeneration === 2">
          <tr>
            <td colspan="3">与本人关系</td>
            <td colspan="3">{{data.tbRelationship&&relationshipList[data.tbRelationship - 1]||'-'}}</td>
          </tr>
        </template>
        <template v-if="data.currentGeneration === 1">
          <tr>
            <td style="width:12%">预产期</td>
            <td style="width:19%">{{data.prepareProduction||'-'}}</td>
            <td style="width:12%">怀孕胎数</td>
            <td style="width:19%">{{data.tbPregnancyNumber&&pregnancyNumberList[data.tbPregnancyNumber - 1]||'-'}}</td>
            <td style="width:12%">产后修养地</td>
            <td style="width:26%">{{data.tbRecuperate||'-'}}</td>
          </tr>
          <tr>
            <td style="width:12%">孕周</td>
            <td style="width:19%">{{data.tbWeek||'-'}}</td>
            <td style="width:12%">孕次</td>
            <td style="width:19%">{{data.tbGravidity&&data.tbGravidity+'次'||'-'}}</td>
            <td style="width:12%">产次</td>
            <td style="width:26%">{{data.tbParity&&data.tbParity+'次'||'-'}}</td>
          </tr>
          <tr>
            <td colspan="3">工作单位</td>
            <td colspan="3">{{data.tbCompany||'-'}}</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import titleComponents from '@/components/mother/title'
export default {
  name: 'recordInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      pregnancyNumberList: ['单胎', '双胎', '三胎', '多胎'],
      relationshipList: ['配偶', '父女', '母女', '父子', '母子', '子女', '其他'],
      show: false
    }
  },
  created () {

  },
  computed: {

  },
  methods: {
  },
  components: {
    titleComponents
  }
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);
  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .baseInfo-content {
      display: flex;
      align-content: center;
      margin-bottom: 25px;
      .text {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        margin-right: 60px;
      }
    }
    .ui-box-table {
      table-layout: fixed;
      text-align: center;
      width: 100%;
      border: 1px solid #d8d8d8;
      border-radius: 6px;
      border-collapse: collapse;
      border-style: hidden;
      box-shadow: 0 0 0 1px #e0e0e0;
      overflow: hidden;
      tr {
        border: 1px solid #e0e0e0;
        height: 54px;
        line-height: 54px;
        th {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 700;
          color: #000000;
          text-align: center;
          border: 1px solid #e0e0e0;
        }
        td {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          border: 1px solid #e0e0e0;
          .address {
            margin: 0 20px;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 22px;
            font-style: normal;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: break-all;
          }
          .headImg {
            width: 46px;
            height: 46px;
            margin: 0 auto;
            &.background {
              background: #d8d8d8;
            }
          }
        }
      }
    }
  }
}
</style>
     